import { MetricName, ReliabilityMetrics } from '@canvas/frontend-metrics';

const LAZY_SYNC_LATENCY_BUCKETS_MS = [50, 100, 200, 500, 1_000, 2_000, 5_000, 10_000];

type LazySyncMetricsOptions = {
  timeoutMs: number;
  now?: () => number;
};

export class LazySyncMetrics {
  private startedAt: number | null = null;
  private readonly now: () => number;

  constructor(private readonly options: LazySyncMetricsOptions) {
    this.now = options.now ?? Date.now;
  }

  requestSent() {
    this.startedAt = this.now();

    ReliabilityMetrics.getInstance().success(MetricName.LAZY_SYNC_REQUEST_SENT);
  }

  unappliedUpdate({ lazySyncInFlight }: { lazySyncInFlight: boolean }) {
    ReliabilityMetrics.getInstance().success(MetricName.LAZY_SYNC_UNAPPLIED_UPDATE, {
      lazySyncInFlight: lazySyncInFlight ? 'true' : 'false',
    });
  }

  timeout() {
    ReliabilityMetrics.getInstance().success(MetricName.LAZY_SYNC_TIMEOUT);
  }

  triggeredNoPeer() {
    ReliabilityMetrics.getInstance().success(MetricName.LAZY_SYNC_TRIGGERED_NO_PEER);
  }

  resolved({ remainingPendingStructs }: { remainingPendingStructs: number }) {
    ReliabilityMetrics.getInstance().success(MetricName.LAZY_SYNC_RESOLVED);
    if (remainingPendingStructs > 0) {
      ReliabilityMetrics.getInstance().success(
        MetricName.LAZY_SYNC_RESOLVED_WITH_REMAINING_PENDING,
      );
    }
  }

  completed() {
    const startedAt = this.startedAt;
    if (startedAt === null) {
      return;
    }

    ReliabilityMetrics.getInstance().histogram(
      MetricName.LAZY_SYNC_LATENCY,
      Math.max(0, this.now() - startedAt),
      [...LAZY_SYNC_LATENCY_BUCKETS_MS, this.options.timeoutMs],
    );
  }

  reset() {
    this.startedAt = null;
  }
}
